<template>
    <div 
        class="modal fade"
        id="addAttrezzoModal"
        tabindex="-1"
        aria-labelledby="addContact"
        aria-hidden="true"
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="addContact">
                        {{isEdit ? 'Modifica' : 'Aggiungi'}} Attrezzo
                    </h5>
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    ></button>
                </div>
                <form @submit.prevent="submit">
                <div class="modal-body">
                    <div class="col-md-12 text-start">
                        <label for="nome" class="form-label">Nome:</label>
                        <div class="input-group has-validation">
                            <input type="text" :class="{'form-control':true, 'is-invalid':errors.nome ? true : false}" id="nome" v-model="form.nome" autofocus aria-describedby="nomeFeedback" required>
                            <div v-if="errors.nome" id="nomeFeedback" class="invalid-feedback">
                                {{errors.nome}}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 text-start">
                        <label for="descrizione" class="form-label">descrizione:</label>
                        <div class="input-group has-validation">
                            <input type="text" :class="{'form-control':true, 'is-invalid':errors.descrizione ? true : false}" id="descrizione" v-model="form.descrizione" autofocus aria-describedby="descrizioneFeedback">
                            <div v-if="errors.descrizione" id="descrizioneFeedback" class="invalid-feedback">
                                {{errors.descrizione}}
                            </div>
                        </div>
                    </div> 
                </div>
                <div class="modal-footer">
                    <button
                        type="button"
                        class="btn btn-secondary"
                        data-bs-dismiss="modal"
                    >
                        Annulla
                    </button>
                    <button type="submit" class="btn btn-primary" :disabled="form.processing">
                        {{isEdit ? 'Aggiorna' : 'Salva'}}
                    </button>
                </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import { Modal } from 'bootstrap';

export default {
    props: {
        attrezzo: Object,
        isEdit: Boolean
    },
    data() {
        return {
            modal: null,
            form: this.$inertia.form({
                nome: this.attrezzo ? this.attrezzo.nome : "" ,
                descrizione: this.attrezzo ? this.attrezzo.descrizione : ""
            }),
            errors: {
               nome: null,
               descrizione: null
            },
        };
    },
    mounted() {
        var modalEl = document.getElementById('addAttrezzoModal')
        this.modal = new Modal(modalEl)
        this.modal.show();
        
        modalEl.addEventListener('hidden.bs.modal',  (event) => {
            this.$emit('modelStatusChanged',false)
        })
    },
    methods: {
        close(){
            //this.isOpen = false
        },
        submit() {
            let route = this.isEdit ? this.route("attrezzo.update",this.paziente.id) : this.route("attrezzo.store")
            let method = this.isEdit ? 'patch' : 'post'
            this.form[this.isEdit ?'patch' : 'post'](route, {
                onError: (errors) => {
                    
                    if (Object.entries(errors).length !== 0) {
                        var toast = {
                            bg: "bg-danger",
                        };

                        
                        if (errors.hasOwnProperty("nome")) {
                            toast.message = errors.nome;
                            this.errors.nome = errors.nome;
                        }

                    }
                }, 
                onSuccess: () => {
                    this.form.reset();
                    this.modal.hide();

                }
            });
        },
    },
};
</script>
